import { render, staticRenderFns } from "./gatewayAddRow.vue?vue&type=template&id=622222aa&scoped=true&"
import script from "./gatewayAddRow.vue?vue&type=script&lang=js&"
export * from "./gatewayAddRow.vue?vue&type=script&lang=js&"
import style0 from "./gatewayAddRow.vue?vue&type=style&index=0&id=622222aa&prod&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "622222aa",
  null
  
)

export default component.exports